import React, {useState} from "react";
import {View, TouchableOpacity} from "react-native";
import PtText from "../../core/pt-text/pt-text";
import PtIcon from "../../core/pt-icon/pt-icon";
import {getTranslation} from "../../../helpers/getTranslation";
import {PtOrderPriceDetailsProps} from './pt-order-price-details-props';
import {styles} from './pt-order-price-details-styles';

export default function PtOrderPriceDetails(props: PtOrderPriceDetailsProps) {

  /** labels */
  const priceDetailsLabel = props.priceDetailsLabel || getTranslation('order.history.price.details.label') || 'Price details';

  /** data */
  const erpPricing = props.pricingData || null;

  /** settings */
  const detailsVisible = props.detailsVisible || false;
  const [showDetails, setShowDetails] = useState(detailsVisible);

  const getLastRowStyle = (idx:number) => {
    return idx == erpPricing.length - 1 ? {fontWeight: '600'} : null;
  }

  const togglePriceDetails = () => {
    if(props.detailsVisibleHandler) {
      props.detailsVisibleHandler(!showDetails)
    }
    setShowDetails(!showDetails);
  }

  return (
    <View style={[styles.orderPriceDetailsContainer]}>
      <View style={[styles.orderPriceDetailsHeader]}>
        <TouchableOpacity onPress={() => togglePriceDetails()}>
          <PtText style={[styles.orderPriceDetailsHeaderText]}>
            {priceDetailsLabel}
            <PtIcon iconName={'forward-right'} style={[styles.orderPriceDetailsHeaderText]}/>
          </PtText>
        </TouchableOpacity>
      </View>
      {showDetails && erpPricing ?
        <View style={[styles.flyoutContainer]}>
          <View style={[styles.flyoutHeader]}>
            <PtText style={[styles.flyoutHeaderText]}>{priceDetailsLabel}</PtText>
            <TouchableOpacity onPress={() => togglePriceDetails()}>
              <PtIcon iconName={'close'}/>
            </TouchableOpacity>
          </View>
          {erpPricing.map((price:any, idx:number) => (
            <View style={[styles.flyoutRow]} key={`price-row-${idx}`}>
              <View style={[styles.priceLabel]}>
                <PtText style={[styles.priceLabelText, getLastRowStyle(idx)]}>
                  {price.name}
                </PtText>
              </View>
              <View style={[styles.priceValue]}>
                <PtText style={[styles.priceValueText, getLastRowStyle(idx)]}>
                  {price.value.formattedValue}
                </PtText>
              </View>
            </View>
          ))}
        </View>
        : null
      }
    </View>
  )
}